import {
  EddRequestResponse,
  EddRequestDetailResponse,
} from "@/api/generated-sources/kienlong-pay";
import {
  EddRequestModel,
  EddRequestDetailModel,
  EddRequestStatus,
  EddRequestType,
} from "@/models/EddRequestModel";

export function mapEddRequestModel(dto?: EddRequestResponse): EddRequestModel {
  return {
    id: dto?.id ?? "",
    code: dto?.code ?? "",
    caseId: dto?.caseId ?? "",
    requestType:
      EddRequestType[
        dto?.requestType ??
          ("EXPLAIN_TRANSACTION" as keyof typeof EddRequestType)
      ],
    reason: dto?.reason ?? "",
    status:
      EddRequestStatus[
        dto?.status ?? ("PENDING" as keyof typeof EddRequestStatus)
      ],
    rejectReason: dto?.rejectReason ?? "",
    deadline: dto?.deadline ?? "",
    createdAt: dto?.createdAt ?? "",
  };
}

export function mapEddRequestDetailModel(
  dto?: EddRequestDetailResponse,
): EddRequestDetailModel {
  return {
    id: dto?.id ?? "",
    code: dto?.code ?? "",
    requestType:
      EddRequestType[
        dto?.requestType ??
          ("EXPLAIN_TRANSACTION" as keyof typeof EddRequestType)
      ],
    reason: dto?.reason ?? "",
    status:
      EddRequestStatus[
        dto?.status ?? ("PENDING" as keyof typeof EddRequestStatus)
      ],
    rejectReason: dto?.rejectReason ?? "",
    deadline: dto?.deadline ?? "",
    explanationId: dto?.explanationId ?? "",
    detailExplanation: dto?.detailExplanation ?? "",
    documentUrls: dto?.documentUrls ?? [],
    createdAt: dto?.createdAt ?? "",
  };
}
